export const MARKETING_PREFERENCES_ACKNOWLEDGED =
  'waitrose/my-account/MARKETING_PREFERENCES_ACKNOWLEDGED';
